import React from "react";
import Image from "next/image";
import useTranslation from "next-translate/useTranslation";
import Link from "next/link";

import { ASSETS_URL } from "configs/constant";

import { formatImage } from "@utils/helpers/logic/image";

import iconBlissCenter from "@public/icons/icon-bliss-center.svg";

const Story = ({ data }) => {
  const { t } = useTranslation("about-us");

  return (
    <div className="story-about-us">
      <div className="story-about-us__background" />
      <div className="story-about-us__content">
        <div className="story-about-us__content__top">
          <h2>{t("company.title")}</h2>
          <div />
        </div>

        {data?.map((item) => (
          <React.Fragment key={item?._id}>
            <div className="story-about-us__content__bottom">
              <div className="story-about-us__content__bottom--left">
                <Link href={`/company/${item?.titleSlug || ""}`}>
                  <a target="_blank">
                    <Image
                      src={
                        item?.logo?.length > 0
                          ? `${ASSETS_URL}/${formatImage(item?.logo)}`
                          : iconBlissCenter
                      }
                      alt="icon"
                      layout="fill"
                    />
                  </a>
                </Link>
              </div>
              <div className="story-about-us__content__bottom--right">
                <div
                  dangerouslySetInnerHTML={{
                    __html: item?.description || "",
                  }}
                  className="content"
                />
                <Link href={`/company/${item?.titleSlug || ""}`}>
                  <a target="_blank" className="seemore">
                    {t("company.seemore")}
                  </a>
                </Link>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>

      <div className="story-about-us__icon" />
    </div>
  );
};

export default Story;
